import { AppState } from "./index";

// Selectors for system data
export const selectAdminInfo = (state: AppState) => state.systemData.adminInfo;
export const selectAdminInfoLoading = (state: AppState) => state.systemData.loading;
export const selectAdminInfoError = (state: AppState) => state.systemData.error;

// Selectors for environment info
export const selectEnvInfo = (state: AppState) => state.systemData.envInfo;
export const selectEnvInfoLoading = (state: AppState) => state.systemData.envLoading;
export const selectEnvInfoError = (state: AppState) => state.systemData.envError;

// Derived selectors - now using envInfo instead of adminInfo
export const selectIsProduction = (state: AppState) =>
  state.systemData.envInfo?.isProd ?? false;

export const selectDeploymentEnv = (state: AppState) =>
  state.systemData.envInfo?.deploymentEnv ?? 'dev';

export const selectAvailableEnvironments = (state: AppState) =>
  state.systemData.envInfo?.availableEnvironments ?? [];